module.exports = __webpack_public_path__ + "static/miklat-logo-bb9eefbce5a846d8da3fdee392fe4ac2.png";